import CallError from '../../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../../utils/general';
import searchVersions from '../search-versions';
import { envSetup } from '../setup';

/**
 * Gets available env list per app
 * @param {object} params - an object of params
 * @param {string} params.accessToken - the access token required to get make the request
 */
export default async (params, signal = null) => {
  const requiredParams = ['accessToken', 'appId', 'orgId'];
  const paramsRules = {
    accessToken: { allowedTypes: ['string'] },
    appId: { allowedTypes: ['string'] },
    orgId: { allowedTypes: ['string'] },
  };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  const response = await fetch(`${envSetup.endpoint}/v1/environments/`, {
    signal,
    headers: {
      Authorization: `Bearer ${params.accessToken}`,
      'x-ims-org-id': params.orgId,
      'x-api-key': envSetup.apiKey,
      'x-app-id': params.appId,
    },
  });
  let content = await response.text();
  try {
    content = JSON.parse(content);
    const searchBody = content.map(({ appId, appVersionId }) => ({ appId, versionId: appVersionId }));
    const versions = await searchVersions({
      accessToken: params.accessToken,
      orgId: params.orgId,
      apps: searchBody,
      mode: 'details',
    });
    content = content.map((env) => {
      const { version } = versions.find((v) => v.id === env.appVersionId);
      return {
        ...env,
        deployedVersion: version,
      };
    });
  } catch (e) {
    // response is not json
  }

  if (response && !response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return content;
  }
};
